export function whitelistMatcherContext(ruleAttr) {
  var whitelistSet = new Set(ruleAttr);
  return function whitelistMatcher(runtimeAttr) {
    var isInWhitelist = whitelistSet.has(runtimeAttr);
    return isInWhitelist;
  };
}